<template>
    <div class="major">
        <div class="banner">
            <div class="banner-btn-box">
                <div class="btn-lis1" @click="clickJumpS2">立即购买</div>
                <div class="btn-lis2" @click="clickJumpS1">免费咨询</div>
            </div>
        </div>
      <div class="ding-bg"  @click="clickJumpS1"></div>
      <div class="ding-bg2"></div>
      <div class="ding-bg3"></div>

      <div class="ding-option">
        <div style="width: 80%;height:75%;position: absolute;bottom: 10%;left: 10%;display: flex;justify-content: space-between;align-items: flex-end">
<!--          <img v-for="(item,index) in imgList" :key="index"  :src="[item.active?  item.activeUrl : item.url]" alt="" :class="[item.active? 'active' : 'norml']" @mouseover="imgMouseover($event,index)" @mouseout="imgMouseout($event,index)">-->
          <div class="div1"></div>
          <div class="div2" :class="{ hover: isHovered }"></div>
          <div class="div3" @mouseover="handleMouseOver" @mouseleave="handleMouseLeave"></div>
        </div>
      </div>

      <img src="./img-ding-por/title.webp" alt="" style="height: 100px">
      <div class="ding-service" @click="clickJumpS1">

        <img src="./img-ding-por/service1.webp" alt="" >
        <img src="./img-ding-por/service2.webp" alt="" >
        <img src="./img-ding-por/service3.webp" alt="">
      </div>
      <div class="ding-bg5"></div>
    </div>
</template>

<script>
export default {
   data () {
       return {
           showMore:true,
           controls:false,
         lastCurrent: 1,
         imgSrc1:require('./img-ding-por/option1.webp'),
         imgList:[
           {
             active: false,
             url:require('./img-ding-por/option1.webp'),
             activeUrl:require('./img-ding-por/option1-active.webp')
           },
           {
             active: true,
             url:require('./img-ding-por/option2.webp'),
             activeUrl:require('./img-ding-por/option2-active.webp')
           },
           {
             active: false,
             url:require('./img-ding-por/option3.webp'),
             activeUrl:require('./img-ding-por/option3-active.webp')
           },
         ],
         isHovered: false
       }
   },
   methods: {
        clickControls(){
            this.controls = true
        },
       clickMore(){
           this.showMore=false
       },
       clickClose(){
           this.showMore=true
       },
       clickJumpS1(){
            window.open('https://affim.baidu.com/unique_45505196/chat?siteId=19205659&userId=45505196&siteToken=77fa0eaf9cff4d1ebd63763b42b6da96')
       },
       clickJumpS2(){
            window.open('https://aisite.wejianzhan.com/site/wjzkc6f4/9517af39-7621-4763-97b1-9438d0246fe5?fid=nHcLrHm1rjRsn1f1rHDsnWRYP19xnHR1P7tk&ch=4&bd_vid=nHcLrHm1rjRsn1f1rHDsnWRYP19xnHR1P7tkg1Dsn7tYg1Tvnj6dPH0zrHnd&ch=4&bd_bxst=EiaKwMT00AHb-UZSKfDD02kpV6QpPJKU060000ivGQpb-ze1P0000001wbfvPbfYnYPaPH0zPbRYfYf4rDcvf1m3njRYfHT3wbfsfWN7PWRdfbN5RYdiwR9KwRV2cjPDfRfzwDRknRPDwRm3rDPDnW0kPjK7wj7DnDNjnHmd1aE_DCIwdxRK0000dlnnVkD000KnQ5k2Ws000Kn0Ps02VJivGQj_8pVEmiBvGQpbQU1zVpylsq5jVTHAtq2d_rz4JeMTsrL5VTv1QT5BVqZ2dP5j000Gu-xI')

       },
     imgMouseover(e, index) {

       this.$set(this.imgList[this.lastCurrent],'active', false)
       this.$set(this.imgList[index],'active', true)

     },
     imgMouseout(e, index) {
       if(index== 1) return
       this.$set(this.imgList[this.lastCurrent],'active', true)
       this.$set(this.imgList[index],'active', false)
     },
     handleMouseOver() {
       console.log('这里')
       this.isHovered = true;
       console.log(' this.isHovered', this.isHovered)

     },
     handleMouseLeave() {
       console.log('离开')
       this.isHovered = false;
     }
   }
}
</script>
<style lang='less' scoped>
.major{
    width: 100%;
    text-align: center;
  .banner{
    width:100% ;
    height: 906px;
    background-image: url('./img-ding-por/banner.webp');
    background-size: 100% 100%;
    background-color: #2d73df;
    background-repeat: no-repeat;
    position: relative;
    .banner-btn-box{
      height: 80px;
      position: absolute;
      bottom: 360px;
      left: 212px;
      display: flex;
      align-items: center;
      .btn-lis1{
        width: 213px;
        height: 70px;
        border-radius: 4px;
        color: #007FFF;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 28px;
        letter-spacing: 4px;
        cursor: pointer;
        background-color: white;
        padding-bottom: 3px;
        margin-right: 36px;
      }
      .btn-lis2{
        width: 213px;
        height: 70px;
        border-radius: 4px;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 28px;
        letter-spacing: 4px;
        cursor: pointer;
        background-color: transparent;
        border: 2px solid #fff;
        padding-bottom: 3px;
      }
    }
  }
  .ding-bg {
    width:100%;
    height: 919px;
    background-image: url('./img-ding-por/ding-por-bg1.webp');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    margin: 100px auto;
    cursor:pointer;
  }
  .ding-bg2 {
    width:100%;
    height: 2091px;
    background-image: url('./img-ding-por/ding-por-bg2.webp');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    margin: 100px auto;
  }
  .ding-bg3 {
    width:100%;
    height: 1383px;
    background-image: url('./img-ding-por/ding-por-bg3.webp');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    margin: 100px auto;
  }
  .ding-bg5 {
    width:100%;
    height:743px;
    background-image: url('./img-ding-por/ding-por-bg5.webp');
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
  .ding-option {
    width:100%;
    height: 1089px;
    background-image: url('./img-ding-por/ding-option.webp');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    margin: 100px auto;
    position: relative;
  }

  .ding-service {
    width: 82%;
    height: 640px;
    display: flex;
    justify-content: space-between;
    margin: 100px auto;
    margin-top: 75px;
    cursor: pointer;
  }

  .norml {
    width: 500px;
    height: 300px;
    margin: 20px;

  }

  .active {
    width: 900px;
    height: 714px;
    margin: 20px;
    transition-property:all;
    transition-duration: .3s, 1s;
    transition-timing-function: ease;
  }

  .div1{
    width: 500px;
    height: 300px;
    background-image: url('./img-ding-por/option1.webp');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    transition-property:height;
    transition-duration: .3s, 1s;
    transition-timing-function: ease;
  }
  .div1:hover {
    width: 900px;
    height: 714px;
    background-image: url('./img-ding-por/option1-active.webp');
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
  .div1:hover + .div2{
    width: 500px;
    height: 300px;
    background-image: url('./img-ding-por/option2.webp');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    transition-property:height;
    transition-duration: .3s, 1s;
    transition-timing-function: ease;
  }

  .div2 {
    width: 900px;
    height: 714px;
    background-image: url('./img-ding-por/option2-active.webp');
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
  .hover {
    width: 500px;
    height: 300px;
    background-image: url('./img-ding-por/option2.webp');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    transition-property:height;
    transition-duration: .3s, 1s;
    transition-timing-function: ease;
  }

  .div3{
    width: 500px;
    height: 300px;
    background-image: url('./img-ding-por/option3.webp');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    transition-property:height;
    transition-duration: .3s, 1s;
    transition-timing-function: ease;
  }
  .div3:hover {
    width: 900px;
    height: 714px;
    background-image: url('./img-ding-por/option3-active.webp');
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
}

</style>
